import { render, staticRenderFns } from "./StokEkstreGenel.vue?vue&type=template&id=30fa4ab2&"
import script from "./StokEkstreGenel.vue?vue&type=script&lang=js&"
export * from "./StokEkstreGenel.vue?vue&type=script&lang=js&"
import style0 from "./StokEkstreGenel.vue?vue&type=style&index=0&id=30fa4ab2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports